export default {
  ResloadingInventory: "جاري تحميل المخزون...",
  ResrestaurantInventory: "مخزون المطعم",
  ResrealTimeStock: "لقطة فورية للمخزون",

  RessearchProduct: "ابحث باسم المنتج...",

  Resall: "الكل",
  ResinStock: "متوفر",
  ReslowStock: "مخزون منخفض",
  ResoutOfStock: "غير متوفر",

  RestotalProducts: "إجمالي المنتجات",
  RestotalQuantity: "إجمالي الكمية",

  ResissueToKitchen: " للمطبخ",
  Resreorder: "إعادة طلب",

  Resquantity: "الكمية",
  Resremarks: "ملاحظات",
  Rescancel: "إلغاء",
  Resissue: "صرف",
  Resissuing: "جارٍ الصرف...",
  Resordering: "جارٍ الطلب...",

  ResreorderProduct: "إعادة طلب المنتج",
  RescurrentStock: "المخزون الحالي",
};